cb.define([], function () {
    var PC_pc_presentationclassref_referVM_Extend = {
      doAction: function (name, viewmodel) {
        if (this[name])
            this[name](viewmodel);
      },
      init: function (viewmodel) {
        
        const findItem = function(items, key, value) {
            for(var i = 0; i < items.length; i++) {
                let item = items[i];
                if(item[key] == value) {
                    return item;
                }
                else if(item.children && item.children.length) {
                    let childItem = findItem(item.children, key, value);
                    if(childItem) {
                        return childItem;
                    }
                }
            }
            return null;
        }

        viewmodel.on('beforeAutoSelectKeys', args => {
            try{
                //分类有重名时，修正参照自动选择数据
                let keys = args.keys;
                if(keys && (keys.length || 0) > 1){
                    //获取单据数据
                    let billParams = viewmodel.getParams().where.billData;
                    let dataJson = billParams.data;
                    let data = JSON.parse(dataJson);
                    if(!data) {
                        return;
                    }
                    let item = findItem(args.dataSource, 'id', data[billParams.key.replace('_Name', '')]);
                    if(item) {
                        args.keys.length = 0;
                        args.keys.push(item[args.keyField])
                    }
                }
            }
            catch(e) {
                
            }
        })
      }

    }
    try {
      module.exports = PC_pc_presentationclassref_referVM_Extend;
    } catch (error) {
   
    }
    return PC_pc_presentationclassref_referVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_presentationclassref_referVM.Extend.js